import { client, gql } from 'data-provider';
import { IRole } from 'interfaces';

export const getRoles = async () => {
  const query = gql`
    query ($where: JSON, $sort: SortInput, $start: Int, $limit: Int) {
      roles(where: $where, sort: $sort, start: $start, limit: $limit) {
        id
        name
        description
      }
    }
  `;

  const variables = {
    where: null,
    sort: null,
    start: null,
    limit: null,
  };
  const response = await client.request(query, variables);
  return response.roles as IRole[];
};

export const getRole = async (id: string) => {
  const query = gql`
    query ($id: ID!) {
      role(id: $id) {
        id
        name
        description
      }
    }
  `;

  const variables = { id };
  const data = await client.request(query, variables);
  const { role } = data;
  return role as IRole;
};

export const createRole = async (name: string, description: string) => {
  const mutation = gql`
    mutation ($input: createRoleInputDto!) {
      createRole(input: $input) {
        id
        name
        description
      }
    }
  `;

  const variables = {
    input: { name, description, permissions: [] },
  };
  const response = await client.request(mutation, variables);
  return response.createRole as { id: string; name: string; description: string };
};

export const updateRole = async (id: string, data: { name: string; description: string }) => {
  const mutation = gql`
    mutation ($input: updateRoleInput!) {
      updateRole(input: $input) {
        id
        name
        description
      }
    }
  `;

  const variables = {
    input: { where: { id }, data },
  };
  const response = await client.request(mutation, variables);
  return response.updateRole as { id: string; name: string; description: string };
};

export const deleteRole = async (id: string) => {
  const mutation = gql`
    mutation ($input: deleteRoleInputDto!) {
      deleteRole(input: $input) {
        roleDetails {
          id
        }
      }
    }
  `;

  const variables = {
    input: { id },
  };
  const response = await client.request(mutation, variables);
  return response.deleteRole.roleDetails as { id: string };
};

export const getRolePermissions = async (roleId: string) => {
  const query = gql`
    query ($roleId: String!) {
      rolePermissions(roleId: $roleId)
    }
  `;

  const variables = { roleId: roleId };
  const data = await client.request(query, variables);
  return data.rolePermissions as Array<string>;
};

export const updateRolePermissions = async (roleId: string, permissions: string[]) => {
  const query = gql`
    mutation ($input: setPermissionInput!) {
      updateRolePermissions(input: $input) {
        permissions
      }
    }
  `;
  const variables = { input: { data: { roleId, permissions } } };
  const data = await client.request(query, variables);
  return data.updateRolePermissions.permissions as string[];
};

export const getOrgPermissions = async () => {
  const query = gql`
    query Permissions($where: JSON) {
      permissions(where: $where) {
        description
        value
      }
    }
  `;

  const data = await client.request(query);
  return data.permissions as { description: string; value: string }[];
};
